export enum TariffPlaceholderSelected {
  ua = 'обрано',
  en = 'selected'
}

export enum TariffLocationLabelName {
  ua = 'Місто',
  en = 'City'
}

export enum TariffRegionLabelName {
  ua = 'Область',
  en = 'Region'
}

export enum TariffCourierLabelName {
  ua = 'Кур`єр',
  en = 'Courier'
}

export enum limitStatus {
  limitByAmountOfBag = 'LIMIT_BY_AMOUNT_OF_BAG',
  limitByPriceOfOrder = 'LIMIT_BY_SUM_OF_ORDER'
}

export enum TariffRegionAll {
  ua = 'все',
  en = 'all'
}
